import { useQuery } from '@tanstack/react-query'
import getHolisticPlanIssues from '../../services/ruutsApi/v2/farms/getHolisticPlanIssues'
import { queryKeys } from './queryKeys'

type UseHolisticPlanIssuesParams = {
  farmId: string | undefined
  year: string | undefined
  enabled: boolean
}

export const useHolisticPlanIssues = ({ farmId, year, enabled }: UseHolisticPlanIssuesParams) =>
  useQuery({
    queryKey: queryKeys.holisticPlanIssues(farmId, year),
    queryFn: ({ signal }) =>
      getHolisticPlanIssues({ farmId: farmId as string, year: year as string, signal }),
    enabled: enabled && !!farmId && !!year,
    meta: { suppressGlobalError: true },
  })
